import actionCreatorFactory from 'typescript-fsa'
import {
  CreatePostTemplateRequest, DeletePostTemplateRequest,
  FindPostTemplatesForCurrentUserLightweightRequest,
  UpdatePostTemplateRequest,
} from '@3m5/sm_publish-frontend-api/apis/PostTemplateApi'
import {
  DeferredPost,
  DeferredPostSearchResult,
  MediaFileMetadata,
  PostTemplate,
  PostTemplatesSearchResult,
  Tag,
  TopicsWithMetadataResponse,
  WebResourceMetaData
} from '@3m5/sm_publish-frontend-api/models'
import { PublishPostRequest } from '@3m5/sm_publish-frontend-api/apis/PostApi'
import { DeleteMediaFileRequest, GetMediaFileMetadataRequest, ListMediaFilesRequest, UploadMediaFileRequest, UploadTemporaryMediaFileRequest } from '@3m5/sm_publish-frontend-api/apis/MediaFileApi'
import { CreateTagsRequest } from '@3m5/sm_publish-frontend-api/apis/TagApi'
import {
  ConfirmManualDeferredPostRequest,
  DeclineManualDeferredPostRequest, GetDeferredPostByIdRequest,
  UpdateDeferredPostRequest,
} from '@3m5/sm_publish-frontend-api/apis/DeferredPostApi'
import { UpdatePagePostRequest } from '@3m5/sm_publish-frontend-api/apis/GooglePostApi'
import { IndividualizeTextOperationRequest } from '@3m5/sm_publish-frontend-api/apis/IndividualizationApi'
import { PostingScreen, PostingType } from '../../shared/types/types'
import { GetUrlInformationRequest } from '@3m5/sm_publish-frontend-api/apis/UrlInformationExtractorApi'
import { PagedMediaFileResponse } from '@3m5/sm_publish-frontend-api'

const actionCreator = actionCreatorFactory('POSTING')

/*
 * Actions
 */

export const setUpdateTemplateId = actionCreator<string>('SET_UPDATE_TEMPLATE_ID')
export const setUploadTemporaryMediaFile = actionCreator<MediaFileMetadata | undefined>('SET_UPLOAD_TEMPORYRY_MEDIA_FILE')

export const setPostingScreen = actionCreator<PostingScreen>('SET_POSTING_SCREEN')

export const setPostingType = actionCreator<PostingType>('SET_POSTING_TYPE')

export const getAllTagsInitiated = actionCreator('GET_ALL_TAGS_INITIATED')
export const getAllTags = actionCreator.async<undefined, Tag[]>('GET_ALL_TAGS')

export const createTagsInitiated = actionCreator<CreateTagsRequest>('CREATE_TAGS_INITIATED')
export const createTags = actionCreator.async<CreateTagsRequest, Tag[]>('REATE_TAGS')

export const getTopicsAndMetadataForCurrentUserInitiated = actionCreator('GET_ABO_TOPICS_INITIATED')
export const getTopicsAndMetadataForCurrentUser = actionCreator.async<undefined, TopicsWithMetadataResponse>('GET_ABO_TOPICS')

export const findPostTemplatesForCurrentUserInitiated = actionCreator<FindPostTemplatesForCurrentUserLightweightRequest>('FIND_POST_TEMPLATES_FOR_CURRENT_USER_INITIATED')
export const findPostTemplatesForCurrentUser = actionCreator.async<FindPostTemplatesForCurrentUserLightweightRequest, PostTemplatesSearchResult>('FIND_POST_TEMPLATES_FOR_CURRENT_USER')

export const publishPostInitiated = actionCreator<PublishPostRequest>('PUBLISH_POST_INITIATED')
export const publishPost = actionCreator.async<PublishPostRequest, undefined>('PUBLISH_POST')

export const updatePagePostInitiated = actionCreator<UpdatePagePostRequest>('UPDATE_PAGE_POST_INITIATED')
export const updatePagePost = actionCreator.async<UpdatePagePostRequest, undefined>('UPDATE_PAGE_POST')

export const getDeferredPostByIdtInitiated = actionCreator<GetDeferredPostByIdRequest>('GET_DEFERRED_POST_BY_ID_INITIATED')
export const getDeferredPostById = actionCreator.async<GetDeferredPostByIdRequest, DeferredPost>('GET_DEFERRED_POST_BY_ID')

export const updateDeferredPostInitiated = actionCreator<UpdateDeferredPostRequest>('UPDATE_DEFERRED_POST_INITIATED')
export const updateDeferredPost = actionCreator.async<UpdateDeferredPostRequest, undefined>('UPDATE_DEFERRED_POST')

export const createPostTemplateInitiated = actionCreator<CreatePostTemplateRequest>('CREATE_POST_TEMPLATE_INITIATED')
export const createPostTemplate = actionCreator.async<CreatePostTemplateRequest, undefined>('CREATE_POST_TEMPLATE')

export const updatePostTemplateInitiated = actionCreator<UpdatePostTemplateRequest>('UPDATE_POST_TEMPLATE_INITIATED')
export const updatePostTemplate = actionCreator.async<UpdatePostTemplateRequest, PostTemplate>('UPDATE_POST_TEMPLATE')

export const deletePostTemplateInitiated = actionCreator<DeletePostTemplateRequest>('DELETE_POST_TEMPLATE_INITIATED')
export const deletePostTemplate = actionCreator.async<DeletePostTemplateRequest, undefined>('DELETE_POST_TEMPLATE')

export const getMediaFileMetadataInitiated = actionCreator<GetMediaFileMetadataRequest>('GET_MEDIA_FILE_METADATA_INITIATED')
export const getMediaFileMetadata = actionCreator.async<GetMediaFileMetadataRequest, MediaFileMetadata>('GET_MEDIA_FILE_METADATA')

export const uploadMediaFileInitiated = actionCreator<UploadMediaFileRequest>('UPLOAD_MEDIA_FILE_INITIATED')
export const uploadMediaFile = actionCreator.async<UploadMediaFileRequest, MediaFileMetadata>('UPLOAD_MEDIA_FILE')

export const uploadTemporaryMediaFileInitiated = actionCreator<UploadTemporaryMediaFileRequest>('UPLOAD_TEMPORARY_MEDIA_FILE_INITIATED')
export const uploadTemporaryMediaFile = actionCreator.async<UploadTemporaryMediaFileRequest, MediaFileMetadata>('UPLOAD_TEMPORARY_MEDIA_FILE')

export const listMediaFilesInitiated = actionCreator<ListMediaFilesRequest>('LIST_MEDIA_FILES_INITIATED')
export const listMediaFiles = actionCreator.async<ListMediaFilesRequest, PagedMediaFileResponse>('LIST_MEDIA_FILES')

export const deleteMediaFileInitiated = actionCreator<DeleteMediaFileRequest>('DELETE_MEDIA_FILE_METADATA_INITIATED')
export const deleteMediaFile = actionCreator.async<DeleteMediaFileRequest, undefined>('DELETE_MEDIA_FILE_METADATA')

export const getUrlInformationInitiated = actionCreator<{ data: GetUrlInformationRequest, id?: string }>('GET_URL_INFORMATION_INITIATED')
export const getUrlInformation = actionCreator.async<GetUrlInformationRequest, WebResourceMetaData>('GET_URL_INFORMATION')
export const setUrlInformation = actionCreator<WebResourceMetaData | undefined>('SET_PAGE_SUMMARY_INITIATED')

export const listDeferredPostsInitiated = actionCreator('LIST_DEFERRED_POSTS_INITIATED')
export const listDeferredPosts = actionCreator.async<undefined, DeferredPostSearchResult>('LIST_DEFERRED_POSTS')

export const confirmManualDeferredPostInitiated = actionCreator<ConfirmManualDeferredPostRequest>('CONFIRM_MANUAL_DEFERRED_POST_INITIATED')
export const confirmManualDeferredPost = actionCreator.async<ConfirmManualDeferredPostRequest, undefined>('CONFIRM_MANUAL_DEFERRED_POST')

export const declineManualDeferredPostInitiated = actionCreator<DeclineManualDeferredPostRequest>('DECLINE_MANUAL_DEFERRED_POST_INITIATED')
export const declineManualDeferredPost = actionCreator.async<DeclineManualDeferredPostRequest, undefined>('DECLINE_MANUAL_DEFERRED_POST')

export const individualizeTextInitiated = actionCreator<IndividualizeTextOperationRequest>('INDIVIDUALIZE_TEXT_INITIATED')
export const individualizeText = actionCreator.async<IndividualizeTextOperationRequest, string>('INDIVIDUALIZE_TEXT')

// EP zum laden aller bilder für den User???
